var form = document.querySelector('.suggest-search-form');
if (form) {
    var input = form.querySelector('.search-input');

    var debounce = function(fn, delay) {
        var timer = null;
        return function () {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                fn.apply(context, args);
            }, delay);
        };
    };

    form.addEventListener('submit', function(event){
        event.preventDefault();
    });

    var displayResults = function(results) {
        var previousResults = form.querySelector('.suggest-results');
        if (previousResults){
            previousResults.remove();
        }
        var div = document.createElement('div');
        div.classList.add('suggest-results');
        results.forEach(function(res){
            var a = document.createElement('a');
            a.setAttribute('href', res.url);
            var span = document.createElement('span');
            span.appendChild(document.createTextNode(res.excerpt))
            a.appendChild(span);
            var span2 = document.createElement('span');
            span2.appendChild(document.createTextNode(res.breadcrumb))
            a.appendChild(span2)
            div.appendChild(a);

            a.addEventListener('click', function(e) {
                input.value = '';
                form.querySelector('.suggest-results').remove();
            });
        });
        if (!results.length) {
            var a = document.createElement('a');
            var span = document.createElement('span');
            span.appendChild(document.createTextNode('No result'))
            a.appendChild(span);
            div.appendChild(a);
        }
        form.insertBefore(div, input.nextSibling);
        document.body.addEventListener('click', function() {
            if(form.querySelector('.suggest-results > a')) {
                window.setTimeout(function(){
                    input.value = '';
                    var res = form.querySelector('.suggest-results');
                    if(res) {
                        res.remove();
                    }
                }, 50);
            }
        });
    };

    var runSearch = function() {
        var query = input.value.trim();
        if(query) {

            fetch(form.getAttribute('action') + '?q=' + query)
            .then(resp => resp.json())
            .then(displayResults);

        } else {
            var previousResults = form.querySelector('.suggest-results');
            if (previousResults){
                previousResults.remove();
            }
        }

    }

    input.addEventListener('keyup', debounce(runSearch, 300));

}
